import React from 'react';
import { motion } from 'framer-motion';
import '../styles/aboutus.css';
import maitreya from '../images/maitreya.jpg';
import hemant from '../images/hemant.jpg';

const AnimatedCharacter = ({ char, index, baseDelay, isOrange = false, customStyles = {} }) => {
  return (
    <motion.span
      key={index}
      initial={{ 
        opacity: 0, 
        x: -50,
        rotate: -10
      }}
      whileInView={{ 
        opacity: 1, 
        x: 0,
        rotate: 0
      }}
      transition={{
        delay: baseDelay + index * 0.05,
        type: "spring",
        stiffness: 100,
        damping: 10
      }}
      viewport={{ once: false }}
      style={{
        display: 'inline-block',
        willChange: 'transform, opacity',
        margin: char === ' ' ? '0 0.25em' : '0', 
        color: isOrange ? '#FF6B35' : 'inherit',
        ...customStyles
      }}
      className={`char-${index + 1}`}
    >
      {char}
    </motion.span>
  );
};

const AboutUsHeading = () => {
  const aboutText = "ABOUT";
  const usText = "US";

  return (
    <motion.div
      className="about-header"
      initial={{ opacity: 0, y: -50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, type: "spring" }}
      viewport={{ once: false }}
    >
      <div className="about-heading">
        <div className="heading-wrapper">
          {aboutText.split("").map((char, index) => (
            <AnimatedCharacter
              key={`about-${index}`}
              char={char}
              index={index}
              baseDelay={0.2}
              customStyles={{
                fontFamily: '"Poppins", sans-serif',
                fontWeight: 700,
                fontSize: 'clamp(2.5rem, 5vw, 5rem)',
                color: '#ffffff'
              }}
            />
          ))}
        </div>
        <div className="heading-wrapper">
          {usText.split("").map((char, index) => (
            <AnimatedCharacter
              key={`us-${index}`}
              char={char}
              index={index}
              baseDelay={0.4}
              isOrange={true}
              customStyles={{
                fontFamily: '"Poppins", sans-serif',
                fontWeight: 700,
                fontSize: 'clamp(2.5rem, 5vw, 5rem)'
              }}
            />
          ))}
        </div>
      </div>
    </motion.div>
  );
};

const Founder = ({ image, name, intro }) => (
  <motion.div 
    className="founder-card"
    initial={{ opacity: 0, scale: 0.9 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: false }}
  >
    <div className="founder-image-container">
      <img src={image} alt={`${name} Founder`} className="founder-image" />
    </div>
    <div className="founder-details">
      <h3>{name}</h3>
      <p>{intro}</p>
    </div>
  </motion.div>
);

const AboutUs = () => {
  return (
    <div className="about-us-page">
      <AboutUsHeading />

      <motion.div
        className="about-content"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: false }}
      >
        <motion.p
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, type: "spring" }}
          viewport={{ once: false }}
          className="about-description"
        >
          Nexolve Technologies India stands at the forefront of digital innovation, bridging the gap between visionary ideas and transformative technological solutions. Founded by a team of passionate technologists and creative thinkers, we are more than just a tech company – we are architects of digital experiences that redefine how businesses interact with technology.
        </motion.p>

        <motion.div
          className="vision-mission"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: false }}
        >
          <div className="vision">
            <h2>Our Vision</h2>
            <p>To be a global leader in technological innovation, consistently pushing the boundaries of what's possible in web, mobile, AI, and decentralized technologies.</p>
          </div>

          <div className="mission">
            <h2>Our Mission</h2>
            <p>Empowering businesses through cutting-edge technological solutions, delivering unparalleled value by combining creativity, expertise, and forward-thinking approach to solve complex digital challenges.</p>
          </div>
        </motion.div>

        <motion.div
          className="founders-section"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: false }}
        >
          <h2 className="founders-title">Founded By</h2>
          <div className="founders-container">
            <Founder 
              image={maitreya} 
              name="Maitreya" 
              intro="I'm passionate about creating innovative tech solutions that transform businesses. My vision is to drive digital transformation through cutting-edge technologies."
            />
            <Founder 
              image={hemant} 
              name="Hemant" 
              intro="With a deep commitment to technological excellence, I strive to build scalable and impactful solutions that push the boundaries of what's possible."
            />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default AboutUs;